<svg viewBox="0 0 100 100">
	<circle class="circleWhite" cx="50" cy="50" r="40"></circle>
	<circle class="circleP2" cx="50" cy="50" r="40"></circle>
	<circle class="circleP1" cx="50" cy="50" r="40"></circle>
</svg>
